import React, { useEffect, useState } from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import Tabination from "../../reusableComponents/Tabination";
import SinglePayout from "./SinglePayout";
import CombinedPayout from "./CombinedPayout";

const PayoutLeaderboardIndex = () => {
    const location = useLocation();
    const path = location.pathname.split("/")[2];
    const [activeTab, setActiveTab] = useState(0);

    const items = [
        {
            name: "Single Payout Leaderboard",
            path: "single-payout",
        },
        {
            name: "Combined Payout Leaderboard",
            path: "combined-payout",
        },
    ];

    useEffect(() => {
        switch (path) {
            case "single-payout":
                setActiveTab(0);
                break;
            case "combined-payout":
                setActiveTab(1);
                break;
            default:
                break;
        }
    }, [path]);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="withdrawalPageContainer">
            <div className="pageNavigator">
                <Tabination
                    variant={7}
                    tabItems={items}
                    activeTab={activeTab}
                    breakpoint={560}
                />
            </div>
            <Routes>
                <Route
                    path="/"
                    element={
                        <Navigate
                            to="single-payout"
                            replace={true}
                        />
                    }
                />
                <Route
                    path="single-payout"
                    element={<SinglePayout />}
                />
                <Route
                    path="combined-payout"
                    element={<CombinedPayout />}
                />
                <Route
                    path="*"
                    element={
                        <Navigate
                            to="/"
                            replace={true}
                        />
                    }
                />
            </Routes>
        </div>
    );
};

export default PayoutLeaderboardIndex;
